import { gql } from '@apollo/client'

export const Query = gql`
  query EditPortfolioPage($companyId: ID!, $filters: PortfolioPageFilters) {
    portfolioPages(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        slug
        title
        body
        description
        enabled
        event { id }
      }
    }
  }
`
